import React from 'react'
import PropTypes from 'prop-types'
import ContentContainer from 'components/ContentContainer'

const CodeSetsContentContainer = ({ children }) => (
  <ContentContainer top="calc(22vh - 40px)">
    {children}
  </ContentContainer>
)
CodeSetsContentContainer.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,

}
export default CodeSetsContentContainer
